class CustomTabs extends HTMLElement {
    connectedCallback() {
      const tabs = Array.from(this.querySelectorAll('[slot="tab"]'));
      const contents = Array.from(this.querySelectorAll('[slot="content"]'));
  
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const targetId = tab.dataset.target;
          this.showTab(targetId, index);
        });
      });
    }
  
    showTab(targetId, tabIndex) {
      const contents = Array.from(this.querySelectorAll('[slot="content"]'));
  
      contents.forEach((content) => {
        if (content.dataset.id === targetId) {
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
  
      const tabs = Array.from(this.querySelectorAll('[slot="tab"]'));
      tabs.forEach((tab, index) => {
        if (index === tabIndex) {
          tab.classList.add('tab-active');
        } else {
          tab.classList.remove('tab-active');
        }
      });
  
      this.animateBorder(tabIndex);
    }
  
    animateBorder(activeTabIndex) {
      const tabs = Array.from(this.querySelectorAll('[slot="tab"]'));
      const activeTab = tabs[activeTabIndex];
      const nextTab = tabs[activeTabIndex + 1];
  
      if (!nextTab) return;
  
      const activeTabRect = activeTab.getBoundingClientRect();
      const nextTabRect = nextTab.getBoundingClientRect();
  
      const border = document.createElement('div');
      border.classList.add('border');
      border.style.width = `${nextTabRect.left - activeTabRect.left}px`;
      border.style.height = '2px';
      border.style.position = 'absolute';
      border.style.bottom = '0';
      border.style.left = '0';
      border.style.transition = 'width 0.3s ease';
      activeTab.appendChild(border);
  
      setTimeout(() => {
        border.style.width = '100%';
      }, 50);
  
      setTimeout(() => {
        border.remove();
      }, 300);
    }
  }
  
  customElements.define('custom-tabs', CustomTabs);